import { CommerceMedia } from '@api/types';
import { Gallery, ProductDetailsContext } from '@components';
import { getCommerceMediaByType } from '@utils/media.utils';
import { useContext, useMemo } from 'react';

export const ProductImageGallery = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { commerceMediaCollection = [], productPacakgeYesNo = {}, productLabel = {} } = product;
  const images = useMemo<CommerceMedia[]>(
    () => getCommerceMediaByType(commerceMediaCollection, 'Image', 'photo'),
    [commerceMediaCollection]
  );
  const packageIncludedValue = productPacakgeYesNo?.value;
  const packageIncluded: boolean = packageIncludedValue?.toLowerCase() === 'true';
  const isCampaignProduct = productLabel?.value?.toLowerCase() === 'kampanje';
  return (
    <Gallery
      images={images}
      packageIncluded={packageIncluded}
      isCampaignProduct={isCampaignProduct}
    />
  );
};
